import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cobertura',
  templateUrl: './cobertura.component.html',
  styleUrls: ['./cobertura.component.scss']
})
export class CoberturaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
